import React from 'react';

export default function Liquid({ width, height }) {
  return (
    <svg
      width={width || '35'}
      height={height || '40'}
      viewBox="0 0 35 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.001 30.7534C11.5643 30.7534 6.9714 26.1694 6.9714 20.7446C6.9714 15.1481 15.355 5.31257 16.9995 3.43765C18.641 5.33116 27.0439 15.2953 27.0439 20.7446C27.0439 26.1694 22.4451 30.7534 17.001 30.7534Z"
        fill="#C2E8FF"
        stroke="#4E7AB5"
        strokeLinejoin="round"
      />
      <path
        d="M16.9645 27.063C13.4749 27.063 10.6454 24.2335 10.6454 20.7438"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
